import { type FC } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import { Stack } from '@craft/ui/components/structural';
import { Typography } from '@craft/ui/components/typography';

import { POPUP_HEIGHT_IN_PX } from './helpers';

export const LoadingEntriesDisplay: FC = () => (
  <Stack alignItems='center' height={POPUP_HEIGHT_IN_PX} justifyContent='center' spacing={1}>
    <CircularProgress aria-label='Loading' />
    <Typography color='text.secondary' variant='body2'>
      Loading
    </Typography>
  </Stack>
);
